import { createReducer } from '@common/redux-utils';

import {
  ContractPaymentConfirmationActionType,
  SendPaymentReceiptEmailFailureAction,
  SendPaymentReceiptEmailStartAction,
  SendPaymentReceiptEmailSuccessAction,
  SetEmailAddressesAction
} from './contract-payment-confirmation.actions';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface ContractPaymentConfirmationState {
  readonly emailAddresses: string[];
}

// This is the initial state of the page
export const initialContractPaymentConfirmationState: ContractPaymentConfirmationState = {
  emailAddresses: []
};

function handleSendPaymentReceiptEmailFailure(
  state: ContractPaymentConfirmationState,
  action: SendPaymentReceiptEmailFailureAction
): ContractPaymentConfirmationState {
  return state;
}

function handleSendPaymentReceiptEmailStart(
  state: ContractPaymentConfirmationState,
  action: SendPaymentReceiptEmailStartAction
): ContractPaymentConfirmationState {
  return state;
}

function handleSendPaymentReceiptEmailSuccess(
  state: ContractPaymentConfirmationState,
  action: SendPaymentReceiptEmailSuccessAction
): ContractPaymentConfirmationState {
  return {
    ...state
  };
}

function handleSetEmailAddresses(
  state: ContractPaymentConfirmationState,
  action: SetEmailAddressesAction
): ContractPaymentConfirmationState {
  return {
    ...state,
    emailAddresses: action.emailAddresses
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const ContractPaymentConfirmationReducer = createReducer(initialContractPaymentConfirmationState, {
  [ContractPaymentConfirmationActionType.SendPaymentReceiptEmailFailure]: handleSendPaymentReceiptEmailFailure,
  [ContractPaymentConfirmationActionType.SendPaymentReceiptEmailStart]: handleSendPaymentReceiptEmailStart,
  [ContractPaymentConfirmationActionType.SendPaymentReceiptEmailSuccess]: handleSendPaymentReceiptEmailSuccess,
  [ContractPaymentConfirmationActionType.SetEmailAddresses]: handleSetEmailAddresses
});



// WEBPACK FOOTER //
// ./src/contract/_components/contract-payment/_components/confirmation/contract-payment-confirmation.reducer.ts